// extracted by mini-css-extract-plugin
export default {"container":"AOICE","skeleton":"fvnKl","skeletonButton":"v2aee","whiteBox":"HlMJF","infoContainer":"wTKEs","additionalPeriod":"iCeAo","isHidden":"seDCx","widgetWrapper":"dxWK1"};